import React, { createContext, useContext, useState } from 'react';

const CaseContext = createContext(null);

export const CaseProvider = ({ children }) => {
  const [fullFIR, setFullFIR] = useState(null);
  return (
    <CaseContext.Provider value={{ fullFIR, setFullFIR }}>
      {children}
    </CaseContext.Provider>
  );
};

export const useCaseContext = () => useContext(CaseContext);
